export const getFormTemplatePageLocation = formTemplate => formTemplate?.event?.id ?
  `/spm/events/${formTemplate.event.id}/formTemplatePage` : '/'